import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { URI } from '../settings/uri-constants';
import { LoginService } from './login.service';

@Injectable({ providedIn: 'root' })
export class RoutePermission {
    constructor(
        private loginService: LoginService,
        private router: Router,
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<boolean | UrlTree> {
        const targetUrl = state.url;

        if (this.loginService.skipUrl(targetUrl)) {
            return new Observable<boolean>((observer) => {
                observer.next(true);
                observer.complete();
            });
        }

        return this.loginService.sessionUser.pipe(
            filter((user) => user !== undefined), // wait until sessionUser is resolved (null or valid)
            take(1),
            map((user) => {
                if (user) return true;
                return this.router.createUrlTree([URI.SLASHED_LOGIN]);
            }),
        );
    }
}
